import { connect } from 'react-redux';

import { BuilderStatus } from '../../components/BuilderStatus';
import { compose } from 'ramda';
import { withEmptyRendering } from '../../utils/hoc';
import { INewbuildingLabel, IOnlineDealSettings, TLabelType } from '../../types/newbuildingLabel';
import { IApplicationState } from '../../types/redux';
import { ISeller } from '../../types/newbuilding';

export interface IBuilderStatusStoreProps {
  labelText: string;
  tooltipTitle: string;
  tooltipText: string;
}

export interface IBuilderStatusOwnProps {
  sellers?: ISeller[] | null;
  newbuildingId: number;
  fromDeveloperPropsCount: number;
}

export const getLabelType = (
  newbuildingId: number,
  onlineDealSettings: IOnlineDealSettings[],
  isFromDeveloper: boolean,
  isFromLeadFactory: boolean,
): TLabelType | null => {
  let type: TLabelType | null = null;

  if (isFromDeveloper) {
    type = 'builderOnline';
  }

  if (isFromLeadFactory) {
    type = 'consultantOnline';
  }

  onlineDealSettings.forEach(regionSettings => {
    if (regionSettings.newBuildingIds.includes(newbuildingId) && isFromDeveloper) {
      type = 'onlineDeal';
    }
  });

  return type;
};

export const getTexts = (newbuildingLabel: INewbuildingLabel, type: TLabelType) => {

  return {
    labelText: newbuildingLabel.indicatorTexts[type],
    tooltipTitle: newbuildingLabel.infoTexts[type].title,
    tooltipText: newbuildingLabel.infoTexts[type].text,
  };
};

export function mapStateToProps(state: IApplicationState, ownProps: IBuilderStatusOwnProps): IBuilderStatusStoreProps {
  const { newbuildingLabel } = state;
  const { sellers, fromDeveloperPropsCount, newbuildingId } = ownProps;

  let labels = {
    labelText: '',
    tooltipTitle: '',
    tooltipText: '',
  };

  if (!newbuildingLabel) {
    return labels;
  }

  const isEnabled = newbuildingLabel.isEnabled;
  if (!isEnabled) {
    return labels;
  }

  const isFromDeveloper = Boolean(fromDeveloperPropsCount);
  const isFromLeadFactory = Boolean(sellers && sellers[0] && sellers[0].isLeadFactory);

  if (newbuildingId) {
    const type = getLabelType(newbuildingId, newbuildingLabel.onlineDeal, isFromDeveloper, isFromLeadFactory);

    if (type) {
      labels = getTexts(newbuildingLabel, type);
    }
  }

  return labels;
}

export const shouldHideLabel = (props: IBuilderStatusStoreProps) => {
  return !props.labelText;
};

export const BuilderStatusContainer = compose(
  connect(mapStateToProps),
  withEmptyRendering(shouldHideLabel),
  )(BuilderStatus);
